import { AdSlotConfig } from '../../../../../../app-kit/components/DefineAdSlot/DefineAdSlot';

export type MediaGalleryAdVariant = 'FOR_SALE' | 'FOR_RENT' | 'OFF_MARKET' | 'SOLD';

export const ForSaleAdSlot: AdSlotConfig = {
  path: '/281894996/pca/sale/photo/footer',
  size: [
    [320, 50],
    [320, 100],
  ],
  id: 'div-gpt-ad-1125442-1',
};

export const ForRentAdSlot: AdSlotConfig = {
  path: '/281894996/pca/rent/photo/footer',
  size: [
    [320, 50],
    [320, 100],
  ],
  id: 'div-gpt-ad-1125442-2',
};

export const SoldAdSlot: AdSlotConfig = {
  path: '/281894996/pca/sold/photo/footer',
  size: [
    [320, 50],
    [320, 100],
  ],
  id: 'div-gpt-ad-1125442-3',
};

export const OffMarketAdSlot: AdSlotConfig = {
  path: '/281894996/pca/offmarket/photo/footer',
  size: [
    [320, 50],
    [320, 100],
  ],
  id: 'div-gpt-ad-1125442-4',
};

export const mapSlotConfigFromVariant = (variant: MediaGalleryAdVariant): AdSlotConfig => {
  switch (variant) {
    case 'FOR_RENT':
      return ForRentAdSlot;
    case 'FOR_SALE':
      return ForSaleAdSlot;
    case 'OFF_MARKET':
      return OffMarketAdSlot;
    case 'SOLD':
      return SoldAdSlot;
  }
};
